import styled from 'styled-components';

const ContentContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: #141414;
`;

export default ContentContainer;
